module.exports = __webpack_public_path__ + "static/img/NI.f485333b.svg";